export default __webpack_public_path__ + "static/media/thum1.429f3735.jpg";